import axios, { AxiosRequestConfig } from "axios";
import SnackbarUtils from "../components/NotistackPlus";
import {
  RIMS_COOKIE_CONSTANTS,
  // RIMS_LOCAL_STG_CONSTANTS
} from "../constants";
import i18n from "i18next";
import cookie from "react-cookies";
import { getURLDomain, logoutFunction } from "../common/utils";
import { useConfigStore } from "../store/config";

export type AxiosRequestConfigType = AxiosRequestConfig<any>;
export const basicUrl = process.env.REACT_APP_API_GETWAY;
const URLDomain = getURLDomain();
const redirectURL = `https://portal.${URLDomain}`;
const refreshURL = "/common-auth/refresh";

type ServiceType = {
  baseURL: string | undefined;
};

type Services = Record<string, ServiceType>;

const services: Services = {
  service: {
    baseURL: basicUrl,
  },
};

const instances = {} as any;

for (const key in services) {
  if (services.hasOwnProperty(key)) {
    const options = services[key];
    const instance = axios.create(options);

    instance.interceptors.request.use(
      (config: AxiosRequestConfigType) => {
        const language = useConfigStore.getState()?.language;
        const languageformat = language === "en" ? "" : language;
        const token = cookie.load(RIMS_COOKIE_CONSTANTS.LOGIN_TOKEN);
        // config.withCredentials = true;
        token
          ? (config.headers = {
              "Content-Type":
                config.responseType === "arraybuffer" &&
                JSON.stringify(config.data) === "{}"
                  ? "application/octet-stream;charset=utf-8"
                  : "application/json;charset=utf-8",
              Authorization: `Bearer ${token}`,
              "Accept-Language": languageformat || "",
            })
          : (config.headers = {
              "Content-Type": "application/json;charset=utf-8",
            });
        return config;
      },
      (error) => {
        Promise.reject(error);
      }
    );

    instance.interceptors.response.use(
      (response: any) => {
        if (response.config.responseType !== "arraybuffer") {
          if (response.status) {
            switch (response.status) {
              case 200:
                return response.data;
              case 400:
              case 401:
              case 403:
                if (response.config?.url?.indexOf(refreshURL) > -1) {
                  console.log(process.env.NODE_ENV);
                  
                  if (process.env.NODE_ENV !== "development") {
                    logoutFunction();
                    window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
                  }
                  console.log(
                    "I catch err refreshURL 401/400/403 in request. will return"
                  );
                }
                return;
              default:
                console.log("error", response.data.msg);
            }
          }
        } else {
          return response;
        }
      },
      (err) => {
        if (err.config?.url?.indexOf(refreshURL) > -1) {
          logoutFunction();
          console.log("I catch err refreshURL 401. will return");
          window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
          return;
        } else {
          const currentMsg = err.response.data?.message;
          const currentErrorCode = err?.response?.data?.code;
          switch (err.response.status) {
            case 401:
              SnackbarUtils.error(i18n.t("common.tokenIsExpired"));
              console.log(process.env.NODE_ENV);
              if (process.env.NODE_ENV !== "development") {
                logoutFunction();
                window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
              }
              // logoutFunction();
              // window.location.href = `${redirectURL}?redirect=${window.location.origin}`;
              break;
            case 403:
              break;
            case 500:
              SnackbarUtils.error(
                currentMsg || i18n.t("common.tip.commonErrorMessage")
              );
              break;
            default:
              if (currentErrorCode === 2017 && currentMsg) {
                break;
              }
              SnackbarUtils.error(
                currentMsg || i18n.t("common.tip.commonErrorMessage")
              );
          }
        }
        return Promise.reject(err);
      }
    );
    instances[key] = instance;
  }
}

export default instances;
